/**
 * Quill.js Configuration
 * Centralized configuration for Quill editor and its modules
 */

import Quill from 'quill';
import 'quill-emoji/dist/quill-emoji.css';
import emoji from 'quill-emoji/dist/quill-emoji';

// Register quill-emoji module only once
if (!Quill.imports['modules/quill-emoji']) {
  Quill.register('modules/quill-emoji', emoji);
}

// Export configured Quill
export default Quill;
